




















import Vue from "vue";
import { LocalStorageManager } from "@/plugins/LocalStorageManager";

export default Vue.extend({
    data: () => ({
        currentHeaders: [],
    }),
    props: {
        pageTitle: String,
        initialHeaders: Array,
    },
    watch: {
        initialHeaders() {
            this.syncHeaders();
        },
        currentHeaders() {
            this.emitChange();
        },
    },
    methods: {
        emitChange() {
            this.$emit("onValueChange", this.currentHeaders);
        },
        getLocalStorageKey(headerValue: string) {
            return this.pageTitle + "_" + headerValue + "_visible_column";
        },
        onSwitchChange(headerValue: string, enabled: any) {
            LocalStorageManager.Write(this.getLocalStorageKey(headerValue), enabled ? "true" : "false");
            this.currentHeaders.find((c) => c.value == headerValue).enabled = enabled;
        },
        syncHeaders() {
            if (!this.initialHeaders) return;

            // aggiungo quelli che devo aggiungere
            this.initialHeaders.forEach((c) => {
                if (!this.currentHeaders.map((c) => c.value).includes(c.value)) {
                    this.currentHeaders.push(c);
                }
            });
            let actionsIndex = this.currentHeaders.findIndex((c) => c.value == "actions");
            if (actionsIndex > -1) this.currentHeaders.push(this.currentHeaders.splice(actionsIndex, 1)[0]);

            this.currentHeaders.forEach((header) => {
                this.migrateUndefinedValue(header.value);
                const localStorageKey = this.getLocalStorageKey(header.value);
                const readValue = LocalStorageManager.Read(localStorageKey);

                if (readValue) {
                    header.enabled = readValue == "true";
                } else {
                    LocalStorageManager.Write(localStorageKey, header.enabled ? "true" : "false");
                }
            });
        },
        migrateUndefinedValue(headerValue) {
            const legacyKey = `undefined_${headerValue}_visible_column`;
            const readValue = LocalStorageManager.Read(legacyKey);
            if (readValue != null && readValue != undefined) {
                LocalStorageManager.Write(this.getLocalStorageKey(headerValue), readValue);
                LocalStorageManager.Remove(legacyKey);
            }
        },
    },
    created() {
        this.syncHeaders();
    },
});
